import { render, staticRenderFns } from "./SideBarMenuItem.vue?vue&type=template&id=33555b7f&scoped=true"
import script from "./SideBarMenuItem.vue?vue&type=script&lang=js"
export * from "./SideBarMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SideBarMenuItem.vue?vue&type=style&index=0&id=33555b7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33555b7f",
  null
  
)

export default component.exports